export function delegate(el: Document, evt: string, sel: string, handler: (event: any) => void) {
  const listener = (event: any) => {
    let t = event.target as any;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    while (t && t.matches && t !== this) {
      if (t.matches(sel)) {
        handler.call(t, event);
      }
      t = t.parentNode;
    }
  }
  el.addEventListener(evt, listener);
  return listener;
}
